import { useTranslator } from '@bluebeam/react-i18n';
import { Button } from 'components/lib';
import SelectVisibleLayersModal from 'components/modals/SelectVisibleLayersModal';
import AppStoreContext from 'contexts/AppStoreContext';
import React, { FC, useContext } from 'react';
import { PlacePunch } from 'records/interactions/PlacePunch';
import { ModalState } from 'records/ModalState';

const PlacePunchBtn: FC = () => {
  const { actions, state: appState } = useContext(AppStoreContext);
  const { permissions } = appState.getProject();
  const { translate } = useTranslator(['mapView']);

  function handleCreatePunchClick() {
    const modalState = new ModalState({
      id: 'SelectVisibleLayersModal',
      portal: 'main',
      open: true,
      component: SelectVisibleLayersModal,
      props: {
        subText: translate('mapView:placePunchBtn.firstSelectDrawing'),
        onLayerSelect: (sheetid: string, pageid: string) => {
          // Create Punch interaction!!!
          actions.createInteraction(
            new PlacePunch({
              sheetid,
              pageid,
            })
          );

          actions.clearAllModals();
        },
      },
    });

    actions.createModal(modalState);
  }

  return permissions.createPunch ? (
    <Button
      id="map-place-punch-btn"
      variant="primary"
      size="large"
      style={{ pointerEvents: 'auto' }}
      onClick={handleCreatePunchClick}
    >
      {translate('mapView:buttons.placePunch')}
    </Button>
  ) : null;
};

export default PlacePunchBtn;
